import React from "react";
import { AlertDialog, Flex, Text, Button } from "@radix-ui/themes";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

export function PermissionAlertDialog({ 
  isOpen, 
  onOpenChange, 
  message = "You don't have permission to perform this action" 
}) {
  return (
    <AlertDialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialog.Content style={{ maxWidth: 450 }}>
        <Flex direction="column" align="center" gap="4">
          <Flex 
            justify="center" 
            align="center"
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "var(--orange-3)",
              color: "var(--orange-9)"
            }}
          >
            <ExclamationTriangleIcon width="24" height="24" />
          </Flex>
          
          <Text size="3" align="center" style={{ color: "var(--gray-12)" }}>
            {message}
          </Text>
        </Flex>

        <Flex gap="3" mt="4" align="center" justify="center">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray">
              OK
            </Button>
          </AlertDialog.Cancel>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
}
